<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { SpeckleModelSelect } from '@haskoning/vue-speckle'

import { useProjectSpeckleStore } from '@/stores/projectSpeckle'

import { useSpeckleManagement } from '@/composables/useSpeckleManagement'

const speckleManagement = useSpeckleManagement()

const { isValidInput, setModelInfo } = speckleManagement

const projectSpeckleStore = useProjectSpeckleStore()

const { message } = storeToRefs(projectSpeckleStore)

const sendToSpeckle = async () => {
  await speckleManagement.exportCalculationToSpeckle()
}

onMounted(async () => {
  await setModelInfo()
})
</script>

<template>
  <v-card flat class="mx-4 py-2">
    <SpeckleModelSelect variant="filled" class="my-2"></SpeckleModelSelect>
    <v-text-field
      v-model="message"
      label="Version Message"
      :rules="[(v: string) => !!v || 'Commit message is required']"
    ></v-text-field>
    <v-btn
      :disabled="!isValidInput"
      @click="sendToSpeckle"
      :loading="speckleManagement.speckleExportLoading.value"
    >
      Send to Speckle
    </v-btn>
  </v-card>
</template>
